import { makeStyles } from "@material-ui/core/styles";
import { MuiTheme } from "theme";
import Breakpoints from "common/breakpoints";

export default makeStyles((theme: MuiTheme) => ({
  snackbar: {
    bottom: 60,
    display: "flex",
    justifyContent: "center",
    "& .MuiAlert-root": {
      padding: "6px 12px"
    },
    [theme.breakpoints.up(Breakpoints.SX_720)]: {
      width: `calc(100% - ${theme.widthTabletDrawer}px)`,
      left: "55%"
    },
    [theme.breakpoints.up(Breakpoints.LG_1280)]: {
      width: `calc(100% - ${theme.widthDesktopDrawer}px)`
    }
  },
  successSnack: {
    backgroundColor: "rgba(72, 155, 119, 1)"
  },
  successSnackMessage: {
    fontSize: 16
  },
  menu: {
    paddingTop: 0,
    paddingBottom: 0
  },
  menuDivider: {
    backgroundColor: "#eeeeee"
  },
  menuItem: {
    paddingLeft: 14,
    paddingTop: 0,
    paddingBottom: 0,
    height: 38
  },
  listItemText: {
    fontSize: 13,
    "& .MuiTypography-body1": {
      fontSize: "inherit"
    }
  },
  menuItemIcon: {
    minWidth: 24
  },
  editIcon: {
    fontSize: 14,
    marginLeft: 2
  },
  deleteIcon: {
    fontSize: 17,
    color: theme.palette.warning.dark
  },
  dotsButton: {
    color: theme.palette.text.primary
  },
  dotsButtonActive: {
    color: theme.palette.secondary.dark
  },
  button: {
    width: "50%",
    height: 46
  },
  alert: {
    color: "#be1f32",
    borderColor: "#be1f32"
  },
  editButton: {
    borderColor: "#000000"
  }
}));
